import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
// import PendingForm from './PendingForm';
// import ApproveForm from './ApproveForm';
import useMediaQuery from '@mui/material/useMediaQuery';
// import { IoMdArrowBack } from 'react-icons/io';
import Generalnfo from './Generalnfo';
import Address from './Address';
import Document from './Document';
import BankDetails from './BankDetails';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`vertical-tabpanel-${index}`} aria-labelledby={`vertical-tab-${index}`} {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

export default function VerticalTabs(props) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleNext = () => {
    if (value < 3) {
      setValue((prev) => prev + 1);
    }
  };
  const handleBank = () => {
    if (value < 4) {
      setValue((prev) => prev - 1);
    }
  };
  const orientation = useMediaQuery('(min-width:600px)') ? 'vertical' : 'horizontal';
  const direction = useMediaQuery('(min-width:600px)') ? 'row' : 'column';

  return (
    <>
      {/* <Button sx={{ width: '20px' }} onClick={() => props.setValueEdit(false)}>
        <IoMdArrowBack style={{ color: 'black', fontSize: '20px' }} />
      </Button> */}
      <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', borderRadius:'10px', display: 'flex', flexDirection: direction }}>

        <Tabs
          orientation={orientation}
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{
            borderRight: 1,
            borderColor: 'divider',
            width: useMediaQuery('(min-width:600px)') ? '13%' : '100%',
            height: useMediaQuery('(min-width:600px)') ? '70vh' : '5vh'
          }}
        >
          <Tab label="General Information" {...a11yProps(0)} />
          <Tab label="Address" {...a11yProps(1)} />
          <Tab label="KYC Documents" {...a11yProps(2)} />
          <Tab label="Banking details" {...a11yProps(3)} />
        </Tabs>
        <div style={{ width: useMediaQuery('(min-width:600px)') ? '87%' : '100%' }}>
          <TabPanel value={value} index={0}>
            <Generalnfo
              UserList={props?.UserList}
              setValueEdit={props?.setValueEdit}
              handleNext={handleNext}
              handleBank={handleBank}
              handleStep={props?.handleStep}
              handlePostChange={props?.handlePostChange}
              postData={props?.postData}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Address
              UserList={props?.UserList}
              handleNext={handleNext}
              handleBank={handleBank}
              handleStep={props?.handleStep}
              handlePostChange={props?.handlePostChange}
              postData={props?.postData}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Document
              UserList={props?.UserList}
              handleNext={handleNext}
              handleBank={handleBank}
              handleStep={props?.handleStep}
              handlePostChange={props?.handlePostChange}
              postData={props?.postData}
            />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <BankDetails
              UserList={props?.UserList}
              handleNext={handleNext}
              handleBank={handleBank}
              handleStep={props?.handleSubmit}
              handlePostChange={props?.handlePostChange}
              postData={props?.postData}
            />
          </TabPanel>
        </div>
      </Box>
    </>
  );
}
